// extracted by mini-css-extract-plugin
module.exports = {"signIn":"_34bpn","mantle":"_2bddo","container":"_1S-Fp","box":"_2uXHB","previous_page":"_3GuSd","boxCon":"_3Or03","signIp":"_2ACBp","forgotpassword":"a7RnZ","tip":"_17jg5"};